import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import img2 from '../../assets/images/error-img.png';

export default class TestimonyListCard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<tr key={this.props.tempPid}>
				<td>
					<img src={this.props.img !== '' ? this.props.img : img2} alt="Image of person" title="product-img" className="avatar-md" />
				</td>
				<td>
					<h5 className="font-size-14 text-truncate">
						<Link to={'/ecommerce-product-detail/' + this.props.tempPid} className="text-dark">
							{this.props.firstname} {this.props.lastname}
						</Link>
					</h5>
					<p className="mb-0">
						ID# : <span className="font-weight-medium">{this.props.tempPid}</span>, {this.props.gender === 2 ? 'Male' : 'Female'}
					</p>
				</td>
				<td>{this.props.age}</td>
				<td>{this.props.placeOfBirth}</td>
				<td>Short info</td>
				<td style={{ width: '90px' }} className="text-center">
					<Link
						className="action-icon text-danger"
						to={{
							pathname: '/testimonyVerify',
							//search: "?sort="+ this.props.firstname + "&" + this.props.lastname,
							state: {
								firstname: this.props.firstname,
								lastname: this.props.lastname,
								tempPid: this.props.tempPid,
							},
						}}>
						<i className="mdi mdi-account-check-outline font-size-18"></i> Review
					</Link>
				</td>
			</tr>
		);
	}
}
